<template>
  <div class="print">
    <!-- 1. 헤더 및 결재란 -->
    <section class="section-approval">
      <div class="header-left-area">
        <p class="print-title">{{ $t("사업장 순회") }}</p>
        <div class="division-title mt-10">□ {{ $t("기본정보") }}</div>
      </div>

      <table class="table-approval-field mt-auto">
        <colgroup>
          <col width="38" />
          <col width="112" />
          <col width="112" />
          <col width="112" />
          <col width="112" />
        </colgroup>
        <tr>
          <th rowspan="2" class="gray p-0" style="border-bottom: none;">
            <div class="flex justify-center items-center">
              <p style="writing-mode: vertical-lr">{{ $i18n.locale === "ko" ? $t("결&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;재") : $t("결재") }}</p>
            </div>
          </th>
          <th class="gray">{{ $t("작성자") }}</th>
          <th class="gray">{{ $t("검토자") }}</th>
          <th class="gray">{{ $t("회람자") }}</th>
          <th class="gray">{{ $t("승인자") }}</th>
        </tr>
        <tr>
          <td style="vertical-align: middle; height: 100px; border-bottom: none;">
            <div class="signature-container">
              <img v-if="form.sign1.sign" :src="form.sign1.sign" class="signature-image" />
              <p v-else-if="form.sign1.name" class="name-text">{{ form.sign1.name }}</p>
            </div>
          </td>
          <td style="vertical-align: middle; height: 100px; border-bottom: none;">
            <div class="signature-container">
              <img v-if="form.sign2.sign" :src="form.sign2.sign" class="signature-image" />
              <p v-else-if="form.sign2.name" class="name-text">{{ form.sign2.name }}</p>
            </div>
          </td>
          <td style="vertical-align: middle; height: 100px; border-bottom: none;">
            <div class="signature-container">
              <img v-if="form.sign3.sign" :src="form.sign3.sign" class="signature-image" />
              <p v-else-if="form.sign3.name" class="name-text">{{ form.sign3.name }}</p>
            </div>
          </td>
          <td style="vertical-align: middle; height: 100px; border-bottom: none;">
            <div class="signature-container">
              <img v-if="form.sign4.sign" :src="form.sign4.sign" class="signature-image" />
              <p v-else-if="form.sign4.name" class="name-text">{{ form.sign4.name }}</p>
            </div>
          </td>
        </tr>
      </table>
    </section>

    <!-- 2. 사업장 정보 -->
    <section class="section-businessInfo mb-10">
      <table class="w-full">
        <colgroup>
          <col width="140" />
          <col />
          <col width="140" />
          <col />
        </colgroup>
        <tr>
          <th>{{ $t("회사명") }}</th>
          <td class="text-left px-2">{{ form.stdInfo.field_name }}</td>
          <th>{{ $t("작성자") }}</th>
          <td class="text-left px-2">{{ form.stdInfo.writer_name }}</td>
        </tr>
        <tr>
          <th>{{ $t("작성일") }}</th>
          <td class="text-left px-2">{{ form.stdInfo.date }}</td>
          <th>{{ $t("조사일") }}</th>
          <td class="text-left px-2">{{ form.inputB_5 }}</td>
        </tr>
        <tr>
          <th>{{ $t("작업내용") }}</th>
          <td class="text-left px-2">{{ form.inputB_1 }}</td>
          <th>{{ $t("작업자") }}</th>
          <td class="text-left px-2">{{ form.inputB_4 }}</td>
        </tr>
        <tr>
          <th>{{ $t("수행일시") }}</th>
          <td class="text-left px-2">{{ form.inputB_2 }}</td>
          <th>{{ $t("확인자") }}</th>
          <td class="text-left px-2">{{ form.inputB_3 }}</td>
        </tr>
        <tr>
          <th>{{ $t("점검장소") }}</th>
          <td class="text-left px-2">{{ form.inputB_6 }}</td>
          <th>{{ $t("재해형태") }}</th>
          <td class="text-left px-2" style="color: red">{{ $t(form.inputB_7) }}</td>
        </tr>
      </table>
    </section>

    <!-- 3. 유해·위험요인 조사 -->
    <section class="section-hazard mb-10">
      <div class="division-title">□ {{ $t("유해·위험요인 조사") }}</div>
      <table class="w-full" style="border-top: none">
        <colgroup>
          <col width="140" />
          <col />
          <col width="140" />
          <col />
        </colgroup>
        <tr>
          <th>{{ $t("작업내용") }}</th>
          <td colspan="3" class="text-left px-2 whitespace-pre-wrap">{{ form.inputC_1 }}</td>
        </tr>
        <tr>
          <th>{{ $t("장소") }}</th>
          <td class="text-left px-2">{{ form.inputC_2 }}</td>
          <th>{{ $t("위험정도") }}</th>
          <td class="text-left px-2">{{ form.inputC_3 }}</td>
        </tr>
        <tr>
          <th>{{ $t("사고유형") }}</th>
          <td class="text-left px-2">{{ form.inputC_4 }}</td>
          <th>{{ $t("질병유형") }}</th>
          <td class="text-left px-2">{{ form.inputC_5 }}</td>
        </tr>
      </table>
    </section>

    <!-- 4. 사진대지 -->
    <section class="section-photo mb-10 page-break" v-if="form.photoList && form.photoList.length > 0">
      <div class="division-title">□ {{ $t("사진대지") }}</div>
      <table class="w-full">
        <colgroup>
          <col width="100" />
          <col />
        </colgroup>
        <template v-for="(photo, index) in form.photoList">
          <tr :key="'photo_' + index" v-if="photo.path">
            <td colspan="2" style="height: 450px">
              <img :src="photo.path" class="max-w-full h-full object-contain mx-auto block" />
            </td>
          </tr>
          <tr :key="'desc_' + index" v-if="photo.path">
            <th>{{ $t("내용") }}</th>
            <td class="text-left">{{ photo.input }}</td>
          </tr>
        </template>
      </table>
    </section>

    <!-- 5. 파일첨부 -->
    <section class="section-file mb-10" v-if="form.fileList && form.fileList.length > 0">
      <div class="division-title">□ {{ $t("첨부파일") }}</div>
      <table class="w-full">
        <colgroup>
          <col width="160" />
          <col />
        </colgroup>
        <tr v-for="(file, index) in form.fileList" :key="index">
          <th>{{ $t("파일명") }}</th>
          <td class="text-left">{{ file.fileName }}</td>
        </tr>
      </table>
    </section>
  </div>
</template>

<script>
export default {
  name: "Print",
  props: {
    isPrint: Boolean,
    board: Object,
    form: Object,
  },
};
</script>

<style lang="scss" scoped>
.print {
  .print-title {
    font-size: 32px;
    font-weight: bold;
    color: #000;
    text-align: center;
    padding: 20px 0;
  }
  .division-title {
    font-size: 24px;
    font-weight: bold;
    color: #3c3c3c;
    padding: 1.25rem 0rem;
  }

  .signature-container {
    width: 100%;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;

    .signature-image {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 80px;
      object-fit: contain;
      display: block;
    }
    .name-text {
      font-size: 16px;
      margin-top: 5px;
    }
  }

  table {
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;

    th,
    td {
      border: 1px solid #757575;
      text-align: center;
      font-size: 18px;
      padding: 10px;
      vertical-align: middle;
    }
    th {
      background-color: #ececec;
      font-weight: 500;
    }
    td {
      word-break: break-all;
    }
    .gray {
      background-color: #ececec;
    }
    .text-left {
      text-align: left;
      padding: 10px 14px;
      word-break: break-word;
    }
  }

  .section-approval {
    display: grid;
    grid-template-columns: 1fr auto;
    width: 100%;
    align-items: flex-start;

    .header-left-area {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      padding-top: 20px;
    }

    .table-approval-field {
      width: auto;
      margin-left: 10px;
      tr:last-child {
        th,
        td {
          border-bottom: 1px solid #757575;
        }
      }
    }
  }
}

@media print {
  section {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  .page-break {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}
</style>
